const PathConstants = {
  Home: "/",

  //   auth
  Login: "login",
  Register: "register",
  ForgetPassword: "forget-password",
  VerifyAccount: "verify-account",
  VerifyCode: "verify-code",
  ResetPassword: "reset-password",

  // courses
  Courses: "courses",
  CoursesWithSpecificCategory: "courses/:slug",
  CourseDetails: "course-details/:slug",
  RecordedCourseDetails: "course-details/recorded/:slug",
  Lesson: "lesson/:slug",
  RecordedLiveLesson:"recorded-live-lesson/:slug",
  RecordedLiveLessonForMobile:"recorded-live-lesson",
  LiveLesson: "live-lesson/:courseId/:id",
  // LiveLesson: "live-lesson/:id",
  RecordedCouse: "course/:id",
  LiveCourse: "live-course/:id",
  Activity: "activity/:id",
  Payment: "payment/:id",
  HomeWorks: "homework/:id",
  Solution: "solution/:id",
  RegisterCourse: "course-form/:id",
  RegisterRecordedCourse: "course-form/recorded/:id",

  // profile
  Profile: "profile",
  ProfileDetails: "details",
  ProfileCourses: "courses",
  ProfileSettings: "settings",
  ProfileWithSpecificCourse: "courses/:id",
  Cv: "cv",

  // others
  TrainerProfile: "trainer-profile/:id",
  Activities: "activities",
  Gallery: "gallery",
  ContactUs: "contact-us",
  PrivacyPolicy: "privacy-policy",
  TermsAndConditions: "terms-and-conditions",
  ScientificCertified: "scientific-certified",
  EndSession: "end-session",
  // EndSession: "end-session/:courseId",
};

export default PathConstants;
